import { __extends } from "tslib";
import * as React from "react";
import classnames from "classnames";
import "./Preloader.css";
import logoUrl from "../MoveLogo/logo.png";
var Preloader = (function (_super) {
    __extends(Preloader, _super);
    function Preloader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Preloader.prototype.render = function () {
        var className = this.props.className;
        var preloaderClass = classnames("Preloader", "preloader", className);
        var circleStyle = {
            width: this.props.size,
            height: this.props.size,
            borderRadius: this.props.size / 2,
            borderWidth: this.props.size / 8
        };
        var logo = this.props.hasLogo ? (React.createElement("img", { alt: "TomTom Logo", src: logoUrl, width: this.props.logoWidth })) : (false);
        return (React.createElement("div", { className: preloaderClass, id: "preloader" },
            logo,
            React.createElement("div", { className: "Preloader__circle", style: circleStyle })));
    };
    Preloader.defaultProps = {
        size: 30
    };
    return Preloader;
}(React.Component));
export { Preloader };
export default Preloader;
